export const generateClassNames = (props, currentIndex, viewEng, checkSub) => {
    const { rowData } = props;
    const textLength = rowData?.text?.length || 0;
    const text2Length = rowData?.text2?.length || 0;
    const duration = rowData?.duration || 1;

    return [
        'textarea imputs',
        currentIndex === props.index ? 'highlight' : '',
        checkSub(rowData) ? 'illegal' : '',
        viewEng && (textLength / duration > 28 || rowData?.text?.split('\n')?.some((e) => e.length > 55))
            ? 'cplOrange'
            : '',
        !viewEng && (text2Length / duration > 28 || rowData?.text2?.split('\n')?.some((e) => e.length > 55))
            ? 'cplOrange'
            : '',
        viewEng && (textLength / duration > 24 || rowData?.text?.split('\n')?.some((e) => e.length > 45))
            ? 'cplYellow'
            : '',
        !viewEng && (text2Length / duration > 24 || rowData?.text2?.split('\n')?.some((e) => e.length > 45))
            ? 'cplYellow'
            : '',
    ]
        .join(' ')
        .trim();
};

export const calculateCpsCplLanguage = (rowData, viewEng) => {
    if (rowData?.text === undefined || rowData?.text2 === undefined) {
        return '0/0';
    }

    const duration = rowData?.duration === 0 ? 1 : rowData?.duration || 1;
    const textLength = rowData?.text?.length || 0;
    const text2Length = rowData?.text2?.length || 0;

    if (viewEng) {
        const cps = (textLength / duration).toFixed(0);
        const cpl = rowData?.text?.split('\n')?.map((e) => e.length);
        return `${cps} / ${cpl}`;
    } else {
        const cps = (text2Length / duration).toFixed(0);
        const cpl = rowData?.text2?.split('\n')?.map((e) => e.length);
        return `${cps} / ${cpl}`;
    }
};

export const calculateCpsCplEnglish = (rowData, viewEng) => {
    if (rowData?.Etext === undefined || rowData?.Etext2 === undefined) {
        return '0/0';
    }

    const duration = rowData?.Eduration === 0 ? 1 : rowData?.Eduration || 1;
    const textLength = rowData?.Etext?.length || 0;
    const text2Length = rowData?.Etext2?.length || 0;

    if (viewEng) {
        const cps = (textLength / duration).toFixed(0);
        const cpl = rowData?.Etext?.split('\n')?.map((e) => e.length);
        return `${cps} / ${cpl}`;
    } else {
        const cps = (text2Length / duration).toFixed(0);
        const cpl = rowData?.Etext2?.split('\n')?.map((e) => e.length);
        return `${cps} / ${cpl}`;
    }
};
